{
	"title": "Dienst nicht verfügbar (500)",
	"description": "Versuchen Sie, diese Seite zu aktualisieren oder überprüfen Sie Ihre Internetverbindung. Wenn dieser Fehler weiterhin besteht, melden Sie ihn bitte als Fehler, damit wir Maßnahmen ergreifen können.",
	"primaryButtonTitle": "Seite aktualisieren",
	"secondaryButtonTitle": "Fehlerprotokoll kopieren",
	"errorLogCopiedMessage": "Fehlerprotokoll kopiert",
	"traceparentLabel": "Traceparent"
}
